import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Tooltip } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import UtilService from '../../services/util';
import { diamondParameters } from '../../constants/Common';
import { LISTINGPAGES } from '../DiamondList/DiamondListFunctions';
import DeleteConfirmation from '../common/DeleteConfirmation';
import OpenNotification from '../common/CommonButton/OpenNotification';
import Pagination from '../common/Pagination';
import { SEARCH_LIST, DELETE_SEARCH } from '../../constants/apiConstant';
import { setDateFormat } from '../../services/Commonfunction';
import { emptyData } from '../DiamondList';
import { store } from 'appRedux/store/index';

let gridHeight = 0;
export function setGridHeightFn() {
  const allContainers = {};
  let totalHeight = window.innerHeight - 66;
  allContainers.headerHeight = document.getElementsByClassName('headerTopMenu')[0];
  allContainers.pageHeadHeight = document.getElementsByClassName('accountTopBlock')[0];
  allContainers.pinHeight = document.getElementsByClassName('accountTabBox')[0];
  allContainers.actionBtnHeight = document.getElementsByClassName('botoomStickyBar')[0];
  allContainers.covidStrip = document.getElementsByClassName('covidStrip')[0];
  allContainers.HeaderStripBlock = document.getElementsByClassName('HeaderStripBlock')[0];
  allContainers.smallHeaderWrapper = document.getElementsByClassName('smallHeaderWrapper ')[0];
  Object.keys(allContainers).map((key) => {
    if (allContainers[key] && allContainers[key].offsetHeight) {
      totalHeight = totalHeight - allContainers[key].offsetHeight;
    }
    return true;
  });
  return totalHeight;
}
class MyDemand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      total: 0,
      page: 1,
      limit: 10,
      showModal: false,
      id: '',
      gridHeight: 0,
      loading: false,
    };
  }

  componentDidMount() {
    this.getData();
  }
  componentDidUpdate(prevProps) {
    if (this.props.commonData.strip !== prevProps.commonData.strip) this.forceUpdate();
  }
  getData() {
    const self = this;
    self.setState({ loading: true });
    const obj = {
      type: 3,
      page: self.state.page,
      limit: self.state.limit,
      isAppendMasters: true,
      labGrown: store.getState().commonData.labGrown,
    };

    const api = SEARCH_LIST.url;
    const objData = {
      method: SEARCH_LIST.method,
      url: api,
      request: obj,
    };

    UtilService.callApi(objData, (err, data) => {
      self.setState({ loading: false });

      if (err) {
        if (err.data && err.data.code === 'E_NOT_FOUND') {
          return self.setState({ rows: [], total: 0 });
        } else {
          throw err;
        }
      }
      if (data && data.code === 'OK') {
        self.setState({ rows: data.data.list, total: data.data.count });
      }
    });
  }

  handleDelete() {
    const self = this;
    const obj = {
      id: this.state.id,
    };
    const api = DELETE_SEARCH.url;
    const objData = {
      method: DELETE_SEARCH.method,
      url: api,
      request: obj,
    };
    UtilService.callApi(objData, async (err, data) => {
      if (err) throw err;
      if (data && data.code === 'OK') {
        if ((self.state.total - 1) % self.state.limit === 0) {
          if (self.state.page > 1) await self.setState({ page: self.state.page - 1 });
        }
        self.setState({ showModal: false, id: '' });
        self.getData();
        OpenNotification({ type: 'success', title: 'Your demand is deleted successfully.' });
      }
    });
  }

  render() {
    const self = this;
    gridHeight = setGridHeightFn();
    return (
      <>
        <div className="savedSearchMainWrapper">
          <div className="savedSearchWrapper" style={{ height: gridHeight, overflow: 'auto' }}>
            {this.state.rows.map((data, index) => (
              <div className="savedSearchItem">
                <div className="savedSearchTop">
                  <span className="savedTitle">
                    {data.name}
                    <span style={{ marginLeft: '20px' }} className="noOfDiamondTitle">
                      {data.expiryDate ? `Expire Date: (${setDateFormat(data.expiryDate)})` : '--'}
                    </span>
                    {/* <span className="noOfDiamondTitle">(No. of Diamond : {data.searchCount})</span> */}
                  </span>
                  <span className=" savedSearchAction">
                    <span className="expireTitle ">
                      {data?.createdAt ? `Date : ${moment(data?.createdAt).format('DD/MM/YY hh:mm A')}` : '- -'}
                    </span>
                    <div className="savedSearchActionItem">
                      <img
                        onClick={() => this.setState({ showModal: !this.state.showModal, id: data.id })}
                        src={require('../../assets/svg/savedSearch/delete.svg')}
                        alt="icon"
                      />
                    </div>
                    <div className="savedSearchActionItem">
                      <img
                        src={require('../../assets/svg/savedSearch/search.svg')}
                        alt="icon"
                        onClick={() => {
                          this.props.history.push('/diamond-list?' + data.id);
                        }}
                      />
                    </div>
                  </span>
                </div>
                <div className="savedSearchBottom">
                  {Object.entries(data.displayData).length === 0 ? (
                    <div className="savedSearchValue">
                      <span>All</span>
                    </div>
                  ) : (
                    Object.keys(data.displayData).map((filter, ind) => {
                      const param = _.find(diamondParameters, { key: filter });
                      if (param) {
                        if (param.key === 'or') {
                          if (_.has(data.displayData['or'][0], 'crt')) {
                            const arr = data.displayData['or'].map((carat) => {
                              return carat['crt']['>='] + ' to ' + carat['crt']['<='];
                            });
                            return (
                              <div className="savedSearchValue" key={ind}>
                                <span>Carat : </span>
                                <span>{_.join(arr, ', ')}</span>
                              </div>
                            );
                          } else if (
                            //Stone ID/ Report Number/ Seller Stone Number
                            _.has(data.displayData['or'][0], 'stoneId') ||
                            _.has(data.displayData['or'][0], 'vStnId')
                          ) {
                            return data.displayData['or'].map((id) => {
                              if (_.keys(id)[0] === 'stoneId') {
                                return (
                                  <div className="savedSearchValue">
                                    <span>Stone ID/ Report Number : </span>
                                    <span>{_.join(_.values(id), ', ')}</span>
                                  </div>
                                );
                              }
                              if (_.keys(id)[0] === 'vStnId') {
                                return (
                                  <div className="savedSearchValue" key={ind}>
                                    <span>Seller Stone Number : </span>
                                    <span>{_.join(_.values(id), ', ')}</span>
                                  </div>
                                );
                              }
                            });
                          }
                        } else if (param.key === 'vnd') {
                          const arr = data.displayData['vnd'].map((v) => {
                            return v.companyName;
                          });
                          return (
                            <div className="savedSearchValue" key={ind}>
                              <span>{param.name} : </span>
                              <span>{_.join(arr, ', ')}</span>
                            </div>
                          );
                        } else {
                          if (_.isObject(data.displayData[filter]) && !_.isArray(data.displayData[filter])) {
                            if (filter === 'kToSArr') {
                              const arr = Object.values(data.displayData['kToSArr'])[0];
                              const key = Object.keys(data.displayData['kToSArr'])[0];

                              return (
                                <div className="savedSearchValue" key={ind}>
                                  <span>
                                    {param.name}&nbsp;:&nbsp;
                                    <span>{key === 'in' ? 'Contains' : 'Not contains'}</span>
                                  </span>
                                  <span>{_.join(arr, ', ')}</span>
                                </div>
                              );
                            } else {
                              return (
                                <div className="savedSearchValue" key={ind}>
                                  <span>{param.name} : </span>
                                  <span>
                                    {(filter === 'marketingIssueDate'
                                      ? moment(data.displayData[filter]['>=']).format('LL')
                                      : data.displayData[filter]['>=']) +
                                      '  to  ' +
                                      (filter === 'marketingIssueDate'
                                        ? moment(data.displayData[filter]['<=']).format('LL')
                                        : data.displayData[filter]['<='])}
                                  </span>
                                </div>
                              );
                            }
                          } else {
                            let disp = data.displayData[param.key];
                            if (param.key === 'showSrNo') {
                              if (disp.includes(',')) disp = disp.split(',');
                              else disp = disp.split(' ');
                            }
                            return (
                              <div className="savedSearchValue" key={ind}>
                                <span>{param.name} : </span>
                                <span>{_.join(disp, ', ')}</span>
                              </div>
                            );
                          }
                        }
                      }
                    })
                  )}
                </div>
              </div>
            ))}
            {emptyData(this.state.loading, this.state.total)}
          </div>

          <DeleteConfirmation
            showModal={this.state.showModal}
            handleCancel={() => this.setState({ showModal: !this.state.showModal })}
            handleDelete={() => this.handleDelete()}
          />
        </div>
        <Tooltip title="Add New Search">
          <a className="addOption" href="/diamond-search">
            <img src={require('../../assets/svg/plus.svg')} />
          </a>
        </Tooltip>
        <div className="botoomStickyBar bottom-0">
          <div></div>
          <Pagination
            count={this.state.total}
            limit={this.state.limit}
            page={this.state.page}
            onPaginationChange={(page, pageSize) => {
              this.setState({ page: page }, () => {
                this.getData();
              });
            }}
            data={this.state.rows}
            noLimitChange
          />
        </div>
      </>
    );
  }
}

export default connect((props) => {
  return { commonData: props.commonData };
}, {})(withRouter(MyDemand));
